import Vue from 'vue';
import VTooltip from 'v-tooltip';
import detector from '@/utils/mobileDetector';

Vue.use(VTooltip);

VTooltip.options.defaultContainer = 'main';
VTooltip.enabled = !detector.mobile();
